/**
 * The business behind the site, as it appears on its registration.
 *
 * Every page that states who the merchant is — footer, contact section, legal
 * pages, checkout, receipts — reads it from here, so the registered details can
 * only ever be wrong in one place. Card schemes and Airwallex compare these
 * against the merchant's records; a mismatch fails review.
 */

export const COMPANY = {
  /** Registered business name under the Business Registration Ordinance (Cap. 310). */
  legalName: 'Veni Music Company',
  /** Business Registration number, exactly as on the BR certificate. Confirmed by the owner. */
  brNumber: '55606150',
  /** Business address on the BR certificate. Confirmed by the owner. */
  registeredAddress: 'Room 510, Wayson Commercial Building, 28 Connaught Road West, Hong Kong',
  /** The address customers and the payment provider see. Enquiries submitted
   *  through the form are routed separately (CONTACT_TO, set at deploy). */
  email: 'hello@veni.hk',
  phone: '+852 6212 2771',
  website: 'https://veni.hk',
  /** The one jurisdiction every payment is taken under. */
  jurisdiction: 'Hong Kong SAR',
  currency: 'HKD',
};

/**
 * Bounds on a single invoice payment, in HKD. Guardrails rather than policy:
 * the floor blunts card testing — fraudsters probing stolen cards with small
 * charges on any open payment form — and the ceiling catches a mistyped amount
 * before it reaches a card. The API enforces its own copy (PAY_MIN_HKD /
 * PAY_MAX_HKD); these only shape what the form accepts.
 */
export const PAYMENT_LIMITS = { min: 100, max: 500000 };

/** Date the legal pages were last revised. Shown on each of them. */
export const POLICIES_UPDATED = '2026-09-19';

/**
 * Facts not yet confirmed by the business owner. A production build refuses to
 * run while this list is non-empty (see vite.config.js), and the dev server
 * shows a banner listing them — so a guess can never ship as a fact.
 */
export const UNCONFIRMED = [];
